import { type Dispatch, type SetStateAction } from "react";

import clsx from "clsx";

import { type ColumnDef, type Row, type Table } from "@tanstack/react-table";

import { TableCell } from "./table-cell";

interface Props<TData> {
  index: number;
  row: Row<TData>;
  columns: ColumnDef<TData>[];
  table: Table<TData>;
  shouldHighlightOnHover?: boolean;
  currentColumnIndexHovered?: number | null;
  setCurrentColumnIndexHovered?: Dispatch<SetStateAction<number | null>>;
}

export const TableRow = <TData,>({
  index,
  row,
  columns,
  table,
  shouldHighlightOnHover,
  currentColumnIndexHovered,
  setCurrentColumnIndexHovered,
}: Props<TData>) => {
  return (
    <>
      <tr
        className={clsx("h-[1px]", {
          "hover:bg-v2-action-tertiary": shouldHighlightOnHover,
          "bg-v2-secondary": index % 2 === 0,
          "bg-v2-primary": index % 2 === 1,
        })}
      >
        {row.getVisibleCells().map((cell) => (
          <TableCell
            key={cell.id}
            cell={cell}
            columns={columns}
            columnIndex={cell.column.getIndex()}
            headerGroups={table.getHeaderGroups()[0]}
            shouldHighlightOnHover={shouldHighlightOnHover}
            currentColumnIndexHovered={currentColumnIndexHovered}
            setCurrentColumnIndexHovered={setCurrentColumnIndexHovered}
          />
        ))}
      </tr>
      {row.getIsExpanded() &&
        row.subRows.map((row) => (
          <TableRow
            key={row.id}
            index={index}
            row={row}
            columns={columns}
            table={table}
            shouldHighlightOnHover={shouldHighlightOnHover}
            currentColumnIndexHovered={currentColumnIndexHovered}
            setCurrentColumnIndexHovered={setCurrentColumnIndexHovered}
          />
        ))}
    </>
  );
};
